// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-20_P4","main":"index-main-3kr5y"};